import { Status } from '@components/utils/status';

export const RcIconTypeToClass = {
  actions:                 'icon-actions',
  ai:                      'icon-ai',
  'alert-alt':             'icon-alert-alt',
  alert:                   'icon-alert',
  anchor:                  'icon-anchor',
  apple:                   'icon-apple',
  application:             'icon-application',
  apps:                    'icon-apps',
  archive:                 'icon-archive',
  'backup-restore':        'icon-backup-restore',
  backup:                  'icon-backup',
  'brush-icon':            'icon-brush-icon',
  'category-alt':          'icon-category-alt',
  checkmark:               'icon-checkmark',
  'chevron-beginning':     'icon-chevron-beginning',
  'chevron-down':          'icon-chevron-down',
  'chevron-end':           'icon-chevron-end',
  'chevron-left':          'icon-chevron-left',
  'chevron-right':         'icon-chevron-right',
  'chevron-up':            'icon-chevron-up',
  'circle-plus':           'icon-circle-plus',
  cis:                     'icon-cis',
  close:                   'icon-close',
  'cluster-management':    'icon-cluster-management',
  cluster:                 'icon-cluster',
  code:                    'icon-code',
  comment:                 'icon-comment',
  commit:                  'icon-commit',
  compass:                 'icon-compass',
  'confirmation-alt':      'icon-confirmation-alt',
  copy:                    'icon-copy',
  dashboard:               'icon-dashboard',
  dock:                    'icon-dock',
  docker:                  'icon-docker',
  document:                'icon-document',
  'dot-half':              'icon-dot-half',
  'dot-open':              'icon-dot-open',
  dot:                     'icon-dot',
  'downgrade-alt':         'icon-downgrade-alt',
  download:                'icon-download',
  edit:                    'icon-edit',
  elemental:               'icon-elemental',
  endpoints_connected:     'icon-endpoints_connected',
  endpoints_disconnected:  'icon-endpoints_disconnected',
  epinio:                  'icon-epinio',
  error:                   'icon-error',
  explore:                 'icon-explore',
  extension:               'icon-extension',
  'external-link':         'icon-external-link',
  file:                    'icon-file',
  filter_alt:              'icon-filter_alt',
  flask:                   'icon-flask',
  fleet:                   'icon-fleet',
  folder:                  'icon-folder',
  fork:                    'icon-fork',
  gatekeeper:              'icon-gatekeeper',
  gear:                    'icon-gear',
  gemini:                  'icon-gemini',
  git:                     'icon-git',
  github:                  'icon-github',
  gitlab:                  'icon-gitlab',
  globe:                   'icon-globe',
  groups:                  'icon-groups',
  harvester:               'icon-harvester',
  helm:                    'icon-helm',
  hide:                    'icon-hide',
  history:                 'icon-history',
  home:                    'icon-home',
  'info-circle':           'icon-info-circle',
  info:                    'icon-info',
  init_container:          'icon-init_container',
  istio:                   'icon-istio',
  keyboard:                'icon-keyboard',
  keyboard_tab:            'icon-keyboard_tab',
  linux:                   'icon-linux',
  'list-flat':             'icon-list-flat',
  'list-grouped':          'icon-list-grouped',
  lock:                    'icon-lock',
  logging:                 'icon-logging',
  longhorn:                'icon-longhorn',
  marketplace:             'icon-marketplace',
  menu:                    'icon-menu',
  minus:                   'icon-minus',
  monitoring:              'icon-monitoring',
  more:                    'icon-more',
  namespace:               'icon-namespace',
  notifier:                'icon-notifier',
  'notify-announcement':   'icon-notify-announcement',
  'notify-bell':           'icon-notify-bell',
  'notify-busy':           'icon-notify-busy',
  'notify-error':          'icon-notify-error',
  'notify-info':           'icon-notify-info',
  'notify-tick':           'icon-notify-tick',
  'notify-warning':        'icon-notify-warning',
  ollama:                  'icon-ollama',
  openai:                  'icon-openai',
  'os-management':         'icon-os-management',
  pause:                   'icon-pause',
  'pin-outlined':          'icon-pin-outlined',
  pin:                     'icon-pin',
  pipeline:                'icon-pipeline',
  play:                    'icon-play',
  plus:                    'icon-plus',
  pod_security:            'icon-pod_security',
  print:                   'icon-print',
  'question-mark':         'icon-question-mark',
  'quick-action':          'icon-quick-action',
  'rancher-desktop':       'icon-rancher-desktop',
  'rancher-observability': 'icon-rancher-observability',
  'refresh-alt':           'icon-refresh-alt',
  refresh:                 'icon-refresh',
  'repository-alt':        'icon-repository-alt',
  repository:              'icon-repository',
  rio:                     'icon-rio',
  'role-binding':          'icon-role-binding',
  search:                  'icon-search',
  send:                    'icon-send',
  service:                 'icon-service',
  show:                    'icon-show',
  snapshot:                'icon-snapshot',
  'sort-down':             'icon-sort-down',
  'sort-up':               'icon-sort-up',
  sort:                    'icon-sort',
  sources:                 'icon-sources',
  spinner:                 'icon-spinner',
  stackstate:              'icon-stackstate',
  'star-open':             'icon-star-open',
  star:                    'icon-star',
  storage:                 'icon-storage',
  'tag-alt':               'icon-tag-alt',
  terminal:                'icon-terminal',
  'thinking-process':      'icon-thinking-process',
  trash:                   'icon-trash',
  unlock:                  'icon-unlock',
  'upgrade-alt':           'icon-upgrade-alt',
  upload:                  'icon-upload',
  'user-check':            'icon-user-check',
  'user-xmark':            'icon-user-xmark',
  user:                    'icon-user',
  'version-alt':           'icon-version-alt',
  warning:                 'icon-warning',
  windows:                 'icon-windows',
};

export const RcIconSizeToCSS = {
  large:   '25px',
  medium:  '18px',
  small:   '14px',
  inherit: 'inherit'
};

export type RcIconSize = keyof typeof RcIconSizeToCSS;

export type RcIconType = keyof typeof RcIconTypeToClass;

export interface RcIconProps {
  type: RcIconType;
  size?: RcIconSize;
  ariaHidden?: boolean;
  status?: Status | 'inherit';
}
